import { ThunkType } from "../../../../core/store/reducers";
import deleteDeliveryApi from "../api/deleteDelivery";
import { setFetchState, invalidateDelivery } from "../deliveryDataSlice";

export const deleteDelivery = (deliveryId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteDeliveryApi(userId, deliveryId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
  dispatch(invalidateDelivery())
};
